import React, { useEffect, useRef, useState } from 'react';
import { usePricing } from '../../contexts/PricingContext';
interface BriefHeaderProps {
  label: string;
}

/**
 * "Prepared for …" only appears once there's a company name. The presenter
 * can click the label to type one in; nothing (cursor, hover, outline) hints
 * that it's editable.
 */
export function BriefHeader({
  label
}: BriefHeaderProps) {
  const {
    companyName,
    setCompanyName
  } = usePricing();
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);
  const name = companyName.trim();
  const showPreparedFor = editing || name !== '';
  return <header className="flex items-center justify-between pb-3 border-b-2 border-[#141a1f]" data-id="element-658" data-mp="2z017wtlg5noy">
      <span className="brief-display text-[17px] font-extrabold tracking-[0.12em] text-[#14684d]" data-id="element-659" data-mp="3dvh1yym11jlc">
        D2D HIRE
      </span>
      <span onClick={() => setEditing(true)} className="flex items-center text-[12px] font-semibold uppercase tracking-[0.1em] text-[#4a5560] cursor-default select-none" data-id="element-660" data-mp="38yqn2elyku1i">
        {label}
        {showPreparedFor && <>&nbsp;· Prepared for&nbsp;</>}
        {editing ? <input ref={inputRef} value={companyName} onChange={e => setCompanyName(e.target.value)} onBlur={() => setEditing(false)} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === 'Escape') e.currentTarget.blur();
      }} aria-label="Company name" size={Math.max(1, companyName.length)} className="bg-transparent p-0 m-0 border-0 outline-none uppercase tracking-[0.1em] font-semibold text-[#4a5560]" data-id="element-661" data-mp="3njaz502mlafw" /> : name}
      </span>
    </header>;
}